// Main Components
import * as React from "react"
import { Script } from "gatsby"

const ResourcesStructuredData = ({...props}) => {
    //console.log("props: ", props)
    const year = new Date(props.date).getFullYear().toString();

    const jsonLdObject = {
        "@context": "http://www.schema.org",
        "@type": "Article",
        "@id": props.pageUrl,
        "headline": props.pageTitle,
        "description": props.pageDescription,
        "url": "https://doctorgenius.com" + props.pageUrl,
        "image": props.imageURL,
        "inLanguage": "en-US",
        "isFamilyFriendly": "True",
        "copyrightHolder": "Doctor Genius",
        "copyrightYear": year,
        "publisher": {
          "@type": "LocalBusiness",
          "@id": "https://doctorgenius.com/#localbusiness",
          "name": "Doctor Genius",
          "url": "https://doctorgenius.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "16800 Aston St Suite 270",
            "addressLocality": "Irvine",
            "addressRegion": "California",
            "postalCode": "92606",
            "addressCountry": "United States",
          },
          "telephone": "+18774772311",
        },
        "potentialAction": {
          "@type": "ReadAction",
          "target": "https://doctorgenius.com" + props.pageUrl,
        },
      };
      
  return (
        <Script type='application/ld+json'>
            {JSON.stringify(jsonLdObject, null, 2)}
        </Script>
  )
}

export default ResourcesStructuredData
